import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class SMECourseHelper{

    async getMyCourses(params = {}) {
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.SME.COURSES, params);
          return response;
        } catch (error) {
          throw new Error(`Failed to fetch courses: ${error.message}`);
        }
    }
}

export default new SMECourseHelper();